import {
  SERVICEREQUEST_PENDING_LIST,
  SERVICEREQUEST_PENDING_LIST_SUCCESS,
  // MATERIALREQUEST_ROW_LIST,
  // MATERIALREQUEST_ROW_LIST_SUCCESS,
  SR_MODEL_LIST_OPEN,
  SR_MODEL_LIST_CLOSE,
  ALL_SR_ITEMS_CHECKED,
  SR_ITEMS_CHECKED,
  SR_SELECT_ITEM,
  PI_SELECTED_ITEM,
  ADD_TO_SELECTED_ITEM,
  SR_PURCHASEINDENT_LIST,
  MY_SR_PURCHASEINDENT_LIST,
  MY_SR_PURCHASEINDENT_LIST_SUCCESS,
  MY_SR_PI_LIST_COUNT,
  SR_PI_LIST_COUNT,
  SR_PI_LIST_COUNT_SUCCESS,
  SET_PARAMS_SR,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  SR_PI_MODEL_LIST_OPEN,
  SR_PI_MODEL_LIST_CLOSE,
  SR_PURCHASEINDENT_ROW,
  SR_PURCHASEINDENT_ROW_SUCCESS,
  SI_INPUT_CHANGEVALUE,
  SI_SELECT_CHANGEVALUE,
  REMOVE_SELECTED_PRODUCT,
  SR_PURCHASEINDENT_ADD,
  PI_ITEM_HOD_APPROVAL,
  // PII_DEPT_HOD_APPROVAL,
  PI_ROW_LOADING,
  SR_PI_HOD_APPROVE_ADD,
  PI_SR_PRODUCTS_REQUEST_LIST,
  PI_SR_PRODUCTS_REQUEST_LIST_SUCCESS,
  PRODUCTS_ROW_REQUEST,
  PRODUCTS_ROW_REQUEST_SUCCESS,
  PRODUCT_MODEL_CLOSE,
  PRODUCT_MODEL_OPEN,
  SR_PURCHASEINDENT_DELETE,
  TOGGLE_ITEM_MENU,
  LIST_LAYOUT,
  SR_FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  PRODUCT_STORE_QTY,
  PRODUCT_STORE_QTY_SUCCESSFUL,
  SR_DETAILS_MODEL_OPEN,
  SR_DETAILS_MODEL_CLOSE,
  SERVICEREQUEST_ROW_DATA_SUCCESS,
  PI_SR_ITEM_IMAGES,
  PI_SR_ITEM_IMAGES_SUCCESS,
  PRODUCT_ITEM_HISTORY_MODEL_OPEN,
  PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  MRlist: [],
  MRlistChecked: [],
  allItemsCheked: false,

  openMRindex: 0,
  MRrowlist: [],
  MRSelectlist: [],
  PISelectItem: [],
  PIRowList: [],
  PIRowListItem: [],
  Sortvar: {
    code: "INDENT NO",
    createdon: "CREATED ON",
  },
  SortMRVar: {
    materialrequest__id: "MR ID",
    date: "REQUEST DATE",
  },
  params: {
    sistatus: [0],
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    SRcurrentSort: "servicerequest__id",
    sortOrder: "-",
  },
  PISelectItemIDS: [],
  PIListModel: false,
  layout: "list",
  loading: false,
  productslist: [],

  delID: 0,
  reqrowdata: {},
  PIFilterlevel: null,
  showFilterRightSidebar: false,
  PiApprovedItems: [],
  MRItemID: null,
  SRDetailsModel: false,
  SRid: null,
  MRRowData: {},

  productItemLoglist: [],
  productItemHistory_model: false,
};

const SRpurchaseIndent = (state = initialState, action) => {
  switch (action.type) {
    case SERVICEREQUEST_PENDING_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SERVICEREQUEST_PENDING_LIST_SUCCESS:
      var MRnoofpages = Math.ceil(
        action.payload.count / state.params.page_size
      );
      var PISelectMrIds = [].concat.apply(
        [],
        state.PISelectItem.map((item) => {
          return item.piimris.map((mritem) => {
            return mritem.mritem.id;
          });
        })
      );
      var MRlistItems = action.payload.results.filter((item) => {
        item.itemcheck = false;
        item.StockQty = null;
        item.StockQtyLoading = false;
        return PISelectMrIds.indexOf(item.id) === -1;
      });

      // var MRlist = action.payload.results.map((item) => {
      //   item.itemcheck = false;

      //   return item;
      // });

      state = {
        ...state,
        MRlist: MRlistItems,
        loading: false,
        params: {
          ...state.params,
          no_of_pages: MRnoofpages,
        },
        // MRlistModel: true,
        // PISelectItem: [],
      };
      break;
    case PRODUCT_STORE_QTY:
      var MRlistItems2 = state.MRlist.map((item) => {
        if (item.product.id === action.payload.ProductID) {
          item.StockQtyLoading = true;
        }

        return item;
      });

      state = {
        ...state,
        loading: true,
        MRProductID: action.payload.ProductID,
        MRlist: MRlistItems2,
      };
      break;

    case PRODUCT_STORE_QTY_SUCCESSFUL:
      var MRlistStockItems = state.MRlist.map((item) => {
        if (item.product.id === action.payload?.ProductID) {
          item.StockQty =
            action.payload !== null ? action.payload.response.qty : null;
          item.StockQtyLoading = false;
        }

        return item;
      });

      state = {
        ...state,
        loading: false,
        MRlist: MRlistStockItems,
      };
      break;
    case ALL_SR_ITEMS_CHECKED:
      var MRlistItems1 = [];
      if (action.payload.checked === true) {
        MRlistItems1 = state.MRlist.map((item) => {
          item.itemcheck = true;
          return item;
        });
        state.MRlistChecked = MRlistItems1;
        state.allItemsCheked = true;
      } else {
        MRlistItems1 = state.MRlist.map((item) => {
          item.itemcheck = false;
          return item;
        });
        state.MRlistChecked = MRlistItems1;
        state.allItemsCheked = false;
      }
      state = {
        ...state,
        MRlist: MRlistItems1,
      };
      break;
    case SR_ITEMS_CHECKED:
      if (action.payload.checked === true) {
        state.MRlist[action.payload.index].itemcheck = true;
        state = {
          ...state,
          MRlistChecked: [...state.MRlistChecked, { ...action.payload.item }],
          loading: false,
        };
      } else {
        state.MRlist[action.payload.index].itemcheck = false;
        var mrcheckedItem = state.MRlistChecked.filter((item) => {
          return item.id !== action.payload.item.id;
        });

        state = {
          ...state,
          MRlistChecked: mrcheckedItem,
        };
      }

      if (state.MRlist.length === state.MRlistChecked.length) {
        state.allItemsCheked = true;
      } else {
        state.allItemsCheked = false;
      }

      break;
    case PI_SELECTED_ITEM:
      // var mrData = state.MRlist[action.payload.mrIndex];
      // var mritem = mrData.mritems[action.payload.mrItemIndex];

      if (action.payload.checked === true) {
        // if (action.payload.tab === 1) {
        //   // MRlist item check box values
        //   mritem.checked = true;
        //   mrData.mritems[action.payload.mrItemIndex] = mritem;
        //   if (!mrData.itemscheck) {
        //     mrData.itemscheck = true;
        //   }
        //   state.MRlist[action.payload.mrIndex] = mrData;
        // } else if (action.payload.tab === 2) {
        //   // MRrowlist item check box values
        //   state.MRrowlist[action.payload.mrItemIndex].itemcheck = true;
        // }

        //*-------------------Merging Items Code--------------------*//

        // action.payload.item..map().id
        // PISelectItem
        // var PIFilterItem = state.PISelectItem.filter((p) => {
        //   return p.product.id == action.payload.item.product.id;
        // });
        // if (PIFilterItem.length > 0) {
        //   var PISelectItem = state.PISelectItem.map((product) => {
        //     if (product.product.id == action.payload.item.product.id) {
        //       product.qty += action.payload.item.qty;
        //       product.piimris = [
        //         ...product.piimris,
        //         {
        //           qty: action.payload.item.qty,
        //           unit: {
        //             id: action.payload.item.unit.id,
        //             name: action.payload.item.unit.name,
        //           },
        //           mritem: {
        //             id: action.payload.item.id,
        //             availableqty: 0,
        //           },
        //         },
        //       ];
        //     }
        //     return product;
        //   });

        //   state = {
        //     ...state,
        //     PISelectItem: PISelectItem,
        //   };
        // } else {

        //*------------------Merging Items Code---------------------*//
        state = {
          ...state,
          // MRlist: mrlist,
          MRlistChecked: [],
          // params: { ...state.params, search: "" },
          PISelectItemIDS: [...state.PISelectItemIDS, action.payload?.item.id],
          allItemsCheked: false,
          PISelectItem: [
            ...state.PISelectItem,
            {
              MR_Item_id: action.payload.item.id,
              MR_id: action.payload.item.materialrequest_id,
              MRCode: action.payload.item.materialrequest_code,
              product: action.payload.item.product,
              qty:
                action.payload.item.availableqty /
                action.payload.item.unit.units,
              date: action.payload.item.date,
              make: action.payload.item.make,
              description: action.payload.item.description,
              mritemimages: action.payload.item.mritemimages,
              unit: {
                id: action.payload.item.unit.id,
                name: action.payload.item.unit.name,
              },
              piimris: [
                {
                  qty:
                    action.payload.item.availableqty /
                    action.payload.item.unit.units,
                  unit: {
                    id: action.payload.item.unit.id,
                    name: action.payload.item.unit.name,
                  },
                  mritem: {
                    materialrequest_id: action.payload.item.materialrequest_id,
                    mrItem_code: action.payload.item.materialrequest_code,
                    code: action.payload.item.code,
                    // date:action.payload.item.date,
                    // make: action.payload.item.make,
                    // description: action.payload.item.description,
                    id: action.payload.item.id,
                    availableqty: 0,
                  },
                },
              ],
              DelID:
                state.PISelectItem.length === 0
                  ? 1
                  : state.PISelectItem[state.PISelectItem.length - 1].DelID + 1,
              dodelete: false,
            },
          ],
        };

        // }
      } else {
        // if (action.payload.tab === 1) {
        //   mritem.checked = false;
        //   mrData.mritems[action.payload.mrItemIndex] = mritem;
        //   if (mrData.itemscheck) {
        //     mrData.itemscheck = false;
        //   }
        //   state.MRlist[action.payload.mrIndex] = mrData;
        // } else if (action.payload.tab === 2) {
        //   state.MRrowlist[action.payload.mrItemIndex].itemcheck = false;
        // }

        var PIFilterItem = state.PISelectItem.filter((p) => {
          return p.product.id !== action.payload.item.product.id;
        });
        var ids = state.PISelectItemIDS.filter(
          (i) => i !== action.payload.item.MR_Item_id
        );
        state = {
          ...state,
          // MRlist: mrlist1,
          // params: { ...state.params, search: "" },
          MRlistChecked: [],
          allItemsCheked: false,
          PISelectItem: PIFilterItem,
          PISelectItemIDS: ids,
        };
      }
      break;
    case ADD_TO_SELECTED_ITEM:
      state = {
        ...state,

        PISelectItem: [
          ...state.PISelectItem,
          {
            MRCode: action.payload.item.materialrequest_code,
            product: action.payload.item.product,
            qty: action.payload.item.qty,
            date: action.payload.item.date,
            make: action.payload.item.make,
            description: action.payload.item.description,
            unit: {
              id: action.payload.item.unit.id,
              name: action.payload.item.unit.name,
            },
            piimris: [],
            DelID:
              state.PISelectItem.length === 0
                ? 1
                : state.PISelectItem[state.PISelectItem.length - 1].DelID + 1,
            dodelete: false,
          },
        ],
      };
      break;

    //--------------------------------------------------
    // case MATERIALREQUEST_ROW_LIST:
    //
    //   state = {
    //     ...state,
    //     openMRid: action.payload.data.MrId,
    //     openMRindex: action.payload.data.Index,
    //     MRrowlist: [],
    //     loading: true,
    //   };
    //   break;
    // case MATERIALREQUEST_ROW_LIST_SUCCESS:
    //
    //   var PISelectMrItemIds = [].concat.apply(
    //     [],
    //     state.PISelectItem.map((item) => {
    //       return item.piimris.map((mritem) => {
    //         return mritem.mritem.id;
    //       });
    //     })
    //   );
    //
    //   var newMrItem = action.payload.map((i) => {
    //     if (PISelectMrItemIds.indexOf(i.id) > -1) {
    //       i.itemcheck = true;
    //     } else {
    //       i.itemcheck = false;
    //     }
    //     return i;
    //   });
    //
    //   state = {
    //     ...state,
    //     MRrowlist: newMrItem,
    //     loading: false,
    //   };

    //   break;
    case SR_MODEL_LIST_OPEN:
      state = {
        ...state,
        // pintid: action.payload.pintid,
        MRlistModel: true,
      };
      break;
    case SR_MODEL_LIST_CLOSE:
      state = {
        ...state,
        MRlistModel: false,
        params: {
          ...state.params,
          search: "",
        },
      };
      break;

    case SR_SELECT_ITEM:
      state = {
        ...state,
        loading: false,
      };
      break;

    case PI_SR_PRODUCTS_REQUEST_LIST:
      if (action.payload.clearList === true) {
        state.productslist = [];
      }
      state = {
        ...state,
        dataLoading: true,
        loading: true,
        productsModel: true,
      };
      break;
    case PI_SR_PRODUCTS_REQUEST_LIST_SUCCESS:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      var PISelectItem_ids = state.PISelectItem.map((p) => {
        return p.product.id;
      });
      var productslist = action.payload.results.filter((p) => {
        return PISelectItem_ids.indexOf(p.id) === -1;
      });

      state = {
        ...state,
        productslist: [...state.productslist, ...productslist],
        productsCount: action.payload.count,
        // ChangeProductList:
        dataLoading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
        // model: true,
      };
      break;
    case PRODUCTS_ROW_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case PRODUCTS_ROW_REQUEST_SUCCESS:
      state = {
        ...state,
        productRowlist: action.payload.response,
        loading: false,
        PIRowData: {},
        // model: true,
      };
      break;
    case SI_INPUT_CHANGEVALUE:
      var PISelectItem = state.PISelectItem.map((p) => {
        if (p.product.id === action.payload.item?.product.id) {
          p.t_qty = action.payload.value;
          // ?PIMRIS has to maintain when products merging

          if (p.piimris.length !== 0) {
            if (action.payload.value <= p.qty) {
              p.piimris[0].qty = action.payload.value;
            } else {
              p.piimris[0].qty = p.qty;
            }
          }
        }
        return p;
      });
      state = {
        ...state,
        PISelectItem: PISelectItem,
      };
      break;
    case SI_SELECT_CHANGEVALUE:
      var PISItem1 = state.PISelectItem.map((p) => {
        if (p.product.id === action.payload.item?.product.id) {
          p.t_unit = {
            id: action.payload.value,
            name: action.payload.label,
          };
          // ?PIMRIS has to maintain when products merging
          if (p.piimris.length !== 0) {
            p.piimris[0].unit = {
              id: action.payload.value,
              name: action.payload.label,
            };
          }
        }
        return p;
      });

      state = {
        ...state,
        PISelectItem: PISItem1,
      };
      break;
    case REMOVE_SELECTED_PRODUCT:
      state.PISelectItem.map((item) => {
        if (item.DelID === action.payload.DelID) {
          item.dodelete = true;
        }
        return item;
      });
      var deleteItems = state.PISelectItem.filter((item) => {
        return !item.dodelete;
      });

      state = {
        ...state,
        PISelectItem: deleteItems,
      };
      break;
    case MY_SR_PURCHASEINDENT_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_PURCHASEINDENT_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MY_SR_PURCHASEINDENT_LIST_SUCCESS:
      var noofpages1 = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        PIRowList: action.payload.results,
        PIRowListCount: action.payload.count,
        params: {
          ...state.params,
          no_of_pages: noofpages1,
        },
        loading: false,
      };
      break;
    case MY_SR_PI_LIST_COUNT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_PI_LIST_COUNT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_PI_LIST_COUNT_SUCCESS:
      state = {
        ...state,
        PIListCount: action.payload,
        loading: false,
      };

      break;

    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        PIRowData: {
          ...state.PIRowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        PIRowData: {
          ...state.PIRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case SET_PARAMS_SR:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case FILTER_INPUT_CHANGEVALUE:
      state = {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case FILTER_SELECT_CHANGEVALUE:
      state = {
        ...state,
        filterdata: {
          ...state.filterdata,
          [action.payload.key]: action.payload.label,
        },
        params: {
          ...state.params,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case SR_PI_MODEL_LIST_OPEN:
      state = {
        ...state,
        PIListModel: true,
      };
      break;
    case SR_PI_MODEL_LIST_CLOSE:
      state = {
        ...state,
        PIListModel: false,
      };
      break;
    case PRODUCT_MODEL_CLOSE:
      state = {
        ...state,
        productsModel: false,
      };
      break;
    case PRODUCT_MODEL_OPEN:
      state = {
        ...state,
        productsModel: true,
      };
      break;
    case SR_DETAILS_MODEL_OPEN:
      state = {
        ...state,
        SRDetailsModel: true,
        SRid: action.payload.MRID,
        loading: true,
      };
      break;
    case SR_DETAILS_MODEL_CLOSE:
      state = {
        ...state,
        SRDetailsModel: false,
        loading: false,
      };
      break;
    case SERVICEREQUEST_ROW_DATA_SUCCESS:
      var mr_approvals = [];
      mr_approvals = action.payload.sr_approvals.filter((approvale) => {
        if (approvale.srstatus === 3) {
          return approvale.approvedby;
        }
        return 0;
      });

      state = {
        ...state,
        MRRowData: { ...action.payload, userDeptApprovedby: mr_approvals },
        loading: false,
      };
      break;

    case SR_PURCHASEINDENT_ROW:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_PURCHASEINDENT_ROW_SUCCESS:

      var PiApprovedItems = action.payload.siitems.filter((item) => {
        if (item.sistatus === 3) {
          return true;
        }
        return false;
      });

      var selectedItems = action.payload.siitems.map((item, i) => {
        item.DelID = i + 1;
        item.dodelete = false;
        return item;
      });
      state = {
        ...state,
        PIreqRowData: action.payload,
        PIRowData: action.payload,
        PISelectItem: selectedItems,
        PiApprovedItems: PiApprovedItems,

        loading: false,
      };
      break;
    case SR_PURCHASEINDENT_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PI_ITEM_HOD_APPROVAL:
      state = {
        ...state,
        loading: true,
      };
      break;
    // case PII_DEPT_HOD_APPROVAL:
    //   state = {
    //     ...state,
    //     loading: true,
    //   };
    //   break;
    case PI_ROW_LOADING:
      state = {
        ...state,
        // loading: true,
        PIRowData: {
          ...state.PIRowData,
          loading: action.payload,
        },
      };
      break;
    case SR_PI_HOD_APPROVE_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_PURCHASEINDENT_DELETE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case TOGGLE_ITEM_MENU:
      var PIRowList = state.PIRowList.map((i) => {
        if (i.id === action.payload) {
          i.actionMenu = !i.actionMenu;
        } else {
          i.actionMenu = false;
        }

        return i;
      });

      state = {
        ...state,
        PIRowList: PIRowList,
      };
      break;
    case LIST_LAYOUT:
      state = {
        ...state,
        layout: action.payload,
        loading: false,
      };
      break;
    case SR_FILTERS_SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,
        PIFilterlevel: action.payload.PIFilterlevel,
        showFilterRightSidebar: !state.showFilterRightSidebar,
      };
      break;
    case FILTERS_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,
        PIFilterlevel: null,
        showFilterRightSidebar: false,
      };
      break;
    case CLEAR_FILTER:
      state = {
        ...state,
        filterdata: {},
      };
      break;

    case PI_SR_ITEM_IMAGES:
      state = {
        ...state,
        loading: false,
        PIItemID: action.payload.PIItemID,
      };
      break;
    case PI_SR_ITEM_IMAGES_SUCCESS:
      var piitems = state.PIreqRowData.piitems.map((item) => {
        if (item.id === state.PIItemID) {
          item.mritemimages = action.payload;
        }
        return item;
      });
      state = {
        ...state,
        PIreqRowData: { ...state.PIreqRowData, piitems: piitems },
        loading: false,
      };
      break;
    case PRODUCT_ITEM_HISTORY_MODEL_OPEN:
      state = {
        ...state,
        productItemLoglist: action.payload.data,
        loading: false,
        productItemHistory_model: true,
        // model: true,
      };
      break;
    case PRODUCT_ITEM_HISTORY_MODEL_CLOSE:
      state = {
        ...state,
        loading: false,
        productItemHistory_model: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};
export default SRpurchaseIndent;
